import { render, staticRenderFns } from "./FormBuilderView.vue?vue&type=template&id=bae884ba&scoped=true&"
import script from "./FormBuilderView.vue?vue&type=script&lang=js&"
export * from "./FormBuilderView.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderView.vue?vue&type=style&index=0&id=bae884ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae884ba",
  null
  
)

export default component.exports